import { Col, Row } from "rsuite";
import styled from "styled-components";

export const CreateCard = styled.div`
    background-color: ${({ theme }) => theme.colors.backgroundSecondary};
    border-radius: 12px;
    border: 1px solid ${({ theme }) => theme.colors.lightGray}60;
    margin: 16px 0 8px;
    overflow: hidden;
`;

export const CreateCardHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
`;

export const CreateCardTitle = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text};
`;

export const CreateCardBody = styled.div`
    padding: 0 20px 20px;
    border-top: 1px solid ${({ theme }) => theme.colors.lightGray}60;
`;

export const FieldsRow = styled(Row)``;

export const StyledCol = styled(Col)`
    margin-top: 14px;
    padding-right: 8px;
`;

export const CreateActions = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
`;
